exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".frontpage-content {\n  margin: 0 auto;\n  width: 800px;\n  padding: 3em 0;\n  font-size: 20px;\n  font-style: italic; }\n  @media (max-width: 799px) {\n    .frontpage-content {\n      width: 100%;\n      padding: 20px; } }\n  .frontpage-content p {\n    margin-bottom: 20px; }\n  .frontpage-content__cta {\n    margin: 3em 0; }\n    .frontpage-content__cta a {\n      padding: 1em;\n      color: #fffbfb;\n      font-style: normal;\n      background-color: #052453; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/jonshilton/Projects/nick-smith-app/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = 0